@if (hardcoded === 'kampas') {
	<div class="c-offer-card">
		<div [style.background-image]="'url(/assets/img/kampas/logo.png)'" [style.background-size]="'contain'" class="c-offer-card__header"></div>

		<div class="c-offer-card__content">
			<p class="u-title-sub ellipsis-3 u-m-bottom--xxs">{{ 'KAMPAS.TITLE' | translate }}</p>

			<p class="c-offer-card__label">{{ 'KAMPAS.LABEL' | translate }}</p>

			<p class="u-m-top--sm">{{ 'KAMPAS.DESCRIPTION' | translate }}</p>
		</div>

		<div class="c-offer-card__bottom">
			<a [routerLink]="['/', 'kampas']" class="c-btn c-btn--bluegrey">{{ 'OFFER_CARD.MORE_INFO' | translate }}</a>
		</div>
	</div>
} @else if (hardcoded === 'delijn') {
	<div class="c-offer-card">
		<div [style.background-image]="'url(/assets/img/de-lijn.jpg)'" class="c-offer-card__header"></div>

		<div class="c-offer-card__content">
			<p class="u-title-sub ellipsis-3 u-m-bottom--xxs">10-rittenkaart De Lijn</p>

			<p class="c-offer-card__label">Aanvraagformulier</p>

			<p class="u-m-top--sm">Boek je een vakantie via ons? Dan kan je een gratis 10-rittenkaart van De Lijn aanvragen.</p>
		</div>

		<div class="c-offer-card__bottom">
			<a class="c-btn c-btn--bluegrey c-btn--with-icon" href="https://www.iedereenverdientvakantie.be/nl/vervoer" target="_blank">
				Aanvraagformulier
				<tvcore-icon name="external-link"></tvcore-icon>
			</a>
		</div>
	</div>
} @else {
	<div class="c-offer-card">
		<div [style.background-image]="offer.poster?.url ? 'url(' + offer.poster?.url + ')' : 'none'" class="c-offer-card__header">
			@if (offer.fullyBooked) {
				<div [class.c-label--lower]="lowerLabel" class="c-label c-label--red">{{ 'OFFER_CARD.FULLY_BOOKED' | translate }}</div>
			} @else if (offer.newOffer) {
				<div [class.c-label--lower]="lowerLabel" class="c-label">{{ 'OFFER_CARD.NEW' | translate }}</div>
			}

			<button (click)="toggleFavorite()" [class.c-favorite-btn--active]="isFavorite()" class="c-favorite-btn">
				@if (isFavorite()) {
					<tvcore-icon name="heart-filled"></tvcore-icon>
				} @else {
					<tvcore-icon name="heart"></tvcore-icon>
				}
			</button>
		</div>

		<div class="c-offer-card__content">
			<p class="u-title-sub ellipsis-3 u-m-bottom--xxs">{{ offer.name }}</p>

			@if (offer.type !== OffersType.ORGANIZED_HOLIDAY) {
				<p class="c-offer-card__label">
					<tvcore-icon name="tag"></tvcore-icon>
					{{ 'PRODUCT_TYPE.' + offer.subtype | translate }}
				</p>

				<p class="c-offer-card__label">
					<tvcore-icon name="location-pin-alt"></tvcore-icon>
					{{ offer.city }}, {{ 'PROVINCE.' + offer.province | translate }}
				</p>
			}

			<p [innerHTML]="offer.promodescription" class="u-m-top--sm ellipsis-3"></p>
		</div>

		<div class="c-offer-card__bottom">
			@if (offer.pricePublished || user()?.eligibleForDiscount || user()?.socialOrg) {
				@switch (offer.type) {
					@case (OffersType.DAYTRIP) {
						@if (offer.price !== undefined) {
							<p [innerHTML]="formatPrice(offer.price)" class="u-title-sub"></p>
							<p class="c-offer-card__label u-m-bottom--sm">{{ 'PRICE_DESCRIPTION.PER_ADULT' | translate }}</p>
						} @else {
							<p class="c-offer-card__label u-m-bottom--sm">Geen prijzen vermeld.</p>
						}
					}
					@case (OffersType.ACCOMMODATION) {
						@if (offer.pricePeakseason !== undefined) {
							<p class="u-title-sub">
								<span [innerHTML]="formatPrice(offer.pricePeakseason)"></span>
								<span class="u-text--sm u-text--normal u-m-left--tiny">{{ 'PRICE_DESCRIPTION.IN_PEAK_SEASON' | translate }}</span>
							</p>
							<p class="c-offer-card__label u-m-bottom--sm">{{ 'PRICE_DESCRIPTION.' + (offer.accommodationPriceType ?? 'UNKNOWN') | translate }}</p>
						} @else {
							<p class="c-offer-card__label u-m-bottom--sm">Geen prijzen vermeld.</p>
						}
					}
				}
			} @else {
				<p class="c-offer-card__label u-m-bottom--sm">{{ 'DETAIL.NO_PRICING_VISIBLE' | translate }}</p>
			}

			<a [routerLink]="['/', fromFavorites ? 'favorites' : fromShare ? 'share' : 'offers', offer.id]" class="c-btn c-btn--bluegrey">{{ 'OFFER_CARD.MORE_INFO' | translate }}</a>
		</div>
	</div>
}
